import axios from 'axios';

export default class ItemsActionsRepository {
  constructor(publicUrl, customConfig) {
    this.publicUrl = publicUrl;
    this.customConfig = customConfig;
  }

  consume(itemId, payload) {
    return axios.put(
      `${this.publicUrl}/items/${itemId}/consume`,
      payload,
      this.customConfig
    );
  }
  add(itemId, payload) {
    return axios.put(
      `${this.publicUrl}/items/${itemId}/add`,
      payload,
      this.customConfig
    );
  }
}
